import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { DataGrid, GridOverlay, useGridApiContext, useGridSelector, gridPageCountSelector, gridPageSelector, gridPageSizeSelector } from '@mui/x-data-grid'
import Pagination from '@material-ui/lab/Pagination'
import ListAlt from '@material-ui/icons/ListAlt';
import Description from '@material-ui/icons/Description';
import NoteAdd from '@material-ui/icons/NoteAdd';
import Cancel from '@material-ui/icons/Cancel';
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck';
import Menu from '@material-ui/icons/Menu';
import CheckCircle from '@material-ui/icons/CheckCircle';
import SyncAlt from '@material-ui/icons/SyncAlt';
import Search from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Refresh from '@material-ui/icons/Refresh';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import SelectAssignAdminModal from 'components/sdoc-admin/manage/select-assign-admin-modal/index'
import SignSignatureModal from 'components/sdoc-admin/manage/sign-signature-modal/index'
import SureModal from 'components/SureModal'
import { useStoreState } from '../../../../store/index'
import { useStoreRehydrated } from '@store'

import { useHistory } from 'react-router-dom'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { format } from 'date-fns'

import { sdoc, sdocAdmin, admin, adminQoS } from 'api/index'

function CustomPagination() {
	const apiRef = useGridApiContext()
	const page = useGridSelector(apiRef, gridPageSelector)
	const pageSize = useGridSelector(apiRef, gridPageSizeSelector)
	const pageCount = useGridSelector(apiRef, gridPageCountSelector)

	return (
		<Grid className="flex flex-row items-center w-full justify-between px-2">
			<Grid className="flex flex-row items-center">
				<Typography variant="body2" className="mr-2">Rows per page:</Typography>
				<Select
					value={pageSize}
					onChange={(e) => apiRef.current.setPageSize(Number(e.target.value))}
					disableUnderline
				>
					{[5, 10, 25, 50].map((size) => (
						<MenuItem key={size} value={size}>
							{size}
						</MenuItem>
					))}
				</Select>
			</Grid>
			<Pagination
				className="p-2"
				color="primary"
				count={pageCount}
				page={page + 1}
				onChange={(event, value) => apiRef.current.setPage(value - 1)}
				showFirstButton
				showLastButton
			/>
		</Grid>
	)
}


const useStyles = makeStyles(() => {
	return {
		details_button: {
			backgroundColor: '#466AE9',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#466AE9',
			},
		},
		common_button: {
			backgroundColor: '#eee',
			color: '#000',
			'&:hover': {
				backgroundColor: '#eee',
			},
		},
		approve_button: {
			backgroundColor: '#1DBF73',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#1DBF73',
			},
		},
		wait_button: {
			backgroundColor: '#F6B50B',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#F6B50B',
			},
		},
		reject_button: {
			backgroundColor: '#DB4D44',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#DB4D44',
			},
		},
		updated_button: {
			backgroundColor: '#466AE9',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#466AE9',
			},
		},
		cancel_button: {
			backgroundColor: '#DB4D44',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#DB4D44',
			},
		},
		preapprove_button: {
			backgroundColor: '#46E9A4',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#46E9A4',
			},
		},
		waiting_assign_button: {
			backgroundColor: '#FAFAD2',
			color: '#000',
			'&:hover': {
				backgroundColor: '#FAFAD2',
			},
		},

	}
})

// Page Description: สถานะการยื่นแบบหนังสือรับรองตนเอง
export default function SDOCStatus() {
	const isRehydrated = useStoreRehydrated()
	const history = useHistory()
	const classes = useStyles()
	const myInfo = useStoreState(
		s => s.sdocAdminModel.adminMESDOC
	)

	const [rowsWaitStatus, setRowsWaitStatus] = useState([])
	const [pageSize, setPageSize] = useState(10)
	const [currentPage, setCurrentPage] = useState(0)
	const [totalRows, setTotalRows] = useState(0)
	const [activeFilters, setActiveFilters] = useState({})
	const [isDataLoading, setIsDataLoading] = useState(true)
	const [myRole, setMyRole] = useState(null)
	const [myID, setMyID] = useState(null)
	const [checkerAdminList, setCheckerAdminList] = useState([])
	const [signatureAdminList, setSignatureAdminList] = useState([])
	const [sDocID, setSDocID] = useState(null)
	const [checkerAdminID, setCheckerAdminID] = useState('')
	const [selectedSignature, setSelectedSignature] = useState(null)

	// Sure Modal
	const [openSubmitSDocSureModal, setOpenSubmitSDocSureModal] = useState(false)
	const [submitType, setSubmitType] = useState('approve')
	const [remark, setRemark] = useState('')
	const [currentActionSDoc, setCurrentActionSDoc] = useState('')
	const [activeSort, setActiveSort] = useState({ field: 'runningNumber', sort: 'desc' })
	const [sortModel, setSortModel] = useState([
		{
			field: 'runningNumber',
			sort: 'desc',
		},
	]);
	// Native DataGrid column-filter -> API params (merged into every fetch)
	const gridFilterParamsRef = useRef({})
	const gridFilterTimerRef = useRef(null)
	const [gridFilterModel, setGridFilterModel] = useState({ items: [] })

	const [openModalAssignAdmin, setOpenModalAssignAdmin] = useState(false)
	const [openModalAssignSignature, setOpenModalAssignSignature] =
		useState(false)

	const sureModalTitle = useMemo(
		() => {
			if (submitType === 'approve') {
				return 'อนุมัติแบบหนังสือรับรองตนเอง';
			} else if (submitType === 'reject') {
				return 'ไม่อนุมัติแบบหนังสือรับรองตนเอง';
			} else if (submitType === 'requestAdditionDoc') {
				return 'ขอเอกสารเพิ่มเติม';
			} else if (submitType === 'requestModifyInfo') {
				return 'ขอปรับปรุงข้อมูล';
			} else if (submitType === 'rejectchecker') {
				return 'ไม่อนุมัติออกหนังสือรับรองตนเองและส่งกลับไปยังผู้ตรวจสอบ';
			}
		},
		[submitType]
	)

	// filter Dialog / Modal
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState([]);
	const [searchCreate, setSearchCreate] = useState('');
	const [searchLastUpdated, setSearchLastUpdated] = useState('');
	const [isSearching, setIsSearching] = useState(false);
	const [isSaveSearch, setIsSaveSearch] = useState(true);

	const statusOptions = [
		// { value: '0', label: 'ทั้งหมด' },
		{ value: '1', label: 'รอมอบหมาย' },
		{ value: '2', label: 'รอตรวจสอบ/เพิ่มเอกสารแล้ว/ปรับปรุงข้อมูลแล้ว' },
		{ value: '3', label: 'ขอเอกสารเพิ่ม/ขอปรับปรุงเอกสาร' },
		{ value: '4', label: 'รอออกใบรับรอง' },
		{ value: '5', label: 'อนุมัติ' },
		{ value: '6', label: 'ไม่อนุมัติ' },
		{ value: '8', label: 'รอชำระเงิน' },
		{ value: '82', label: 'เลยกำหนดชำระ' },
		{ value: '9', label: 'รอออกใบเสร็จรับเงิน' },
		{ value: '10', label: 'ยกเลิกคำขอ' },
		{ value: '11', label: 'เลยระยะเวลา' },
	];
	const toggleDialog = () => {
		setIsDialogOpen(!isDialogOpen);
	};
	const handleSearchChange = (event) => {
		const { id, value } = event.target;
		setSearchQuery((prevSearchQuery) => {
			const updatedQuery = [...prevSearchQuery];
			const existingItemIndex = updatedQuery.findIndex((item) => item.id === id);
			if (existingItemIndex !== -1) {
				updatedQuery[existingItemIndex] = { id, value };
			} else {
				updatedQuery.push({ id, value });
			}
			return updatedQuery;
		});
		// console.log(searchQuery);
	};

	const handleStatusChange = (event) => {
		setSelectedStatus(event.target.value);
	};
	const handleCreateChange = (event) => {
		setSearchCreate(event.target.value);
	};
	const handleLastUpdatedChange = (event) => {
		setSearchLastUpdated(event.target.value);
	};
	const handleSaveSearch = () => {
		setIsSaveSearch(!isSaveSearch);
	};


	const contentSureModal = useMemo(
		() => {

			if (submitType === 'approve') {
				return <div className="text-center">ยืนยันอนุมัติแบบหนังสือรับรองตนเอง</div>
			} else if (submitType === 'reject') {
				return <TextField
					fullWidth
					multiline
					rows={3}
					type="text"
					label="เหตุผลที่ไม่อนุมัติ"
					autoFocus={true}
					variant="filled"
					size="small"
					onChange={e => {
						setRemark(e.target.value)
					}}
					value={remark}
				/>
			} else if (submitType === 'requestAdditionDoc') {
				return <TextField
					fullWidth
					multiline
					rows={3}
					type="textarea"
					label="เอกสารที่ขอเพิ่มเติม"
					autoFocus={true}
					variant="filled"
					size="small"
					onChange={e => {
						setRemark(e.target.value)
					}}
					value={remark}
				/>
			} else if (submitType === 'requestModifyInfo') {
				return <TextField
					fullWidth
					multiline
					rows={3}
					type="textarea"
					label="ขอปรับปรุงข้อมูล"
					autoFocus={true}
					variant="filled"
					size="small"
					onChange={e => {
						setRemark(e.target.value)
					}}
					value={remark}
				/>
			} else if (submitType === 'rejectchecker') {
				return <TextField
					fullWidth
					multiline
					rows={3}
					type="text"
					label="เหตุผลที่ไม่อนุมัติ และส่งกลับไปยังผู้ตรวจสอบ"
					autoFocus={true}
					variant="filled"
					size="small"
					onChange={e => {
						setRemark(e.target.value)
					}}
					value={remark}
				/>
			}
		},
		[submitType, remark]
	)

	const onOpenModalAssignAdmin = () => {

		setOpenModalAssignAdmin(!openModalAssignAdmin)
	}

	const handleIssueBtn = e => {
		setSDocID(e)
		adminQoS.getSignature().then(e => {
			setSignatureAdminList(e)

			setOpenModalAssignSignature(true)
		})
	}

	const onClickAssignAdmin = sDocID => {
		setSDocID(sDocID)
		setCheckerAdminID('')
		onOpenModalAssignAdmin()
	}

	const onChangeCheckerAdminID = event => {
		setCheckerAdminID(event.target.value)
	}

	const onChangeSignature = event => {
		setSelectedSignature(event.target.value)
	}

	const createWaitingRow = (dataSDocList, i) => {
		const rowData = {
			id: dataSDocList[i].id,
			brandName: dataSDocList[i].brandName,
			operator:
				(dataSDocList[i].sDocUser.prefix ?? '') +
				dataSDocList[i].sDocUser.firstname +
				' ' +
				dataSDocList[i].sDocUser.lastname,
			submitDate: dataSDocList[i].createDate,
			statusID: dataSDocList[i].sDocStatusID,
			// statusID: (i % 6) + 1,
			statusName: dataSDocList[i].sDocStatus.statusName,
			approver: dataSDocList[i].approver
				? dataSDocList[i].approver.firstname +
				' ' +
				dataSDocList[i].approver.lastname
				: 'ยังไม่ได้มอบหมาย',
			productModel: dataSDocList[i].productModel,
			runningNumber: dataSDocList[i].runningNo,
			requestAddtionDocStatusID: dataSDocList[i].requestAddtionDocStatusID,
			operatorInfo: dataSDocList[i].senderType === 'organization' ? dataSDocList[i].operatorTitle : null,
			transactions: dataSDocList[i].sDocTransactions,
		}
		return rowData
	}

	const getSDocStatusList = async () => {
		// Get Status List
		const resStatusList = await sdoc.getListsStatus()
		const dataStatusList = resStatusList.data
		const statusListTemp = []
		if (resStatusList) {
			if (resStatusList.status === 200) {
				for (let i = 0; i < dataStatusList.length; i++) {
					statusListTemp.push({
						id: dataStatusList[i].id,
						statusName: dataStatusList[i].statusName,
					})
				}
			}
		}
		return statusListTemp
	}

	const getCheckerAdminList = async () => {
		const resAdminList = await sdocAdmin.getAdminList()

		const adminListTemp = []
		if (resAdminList) {
			if (resAdminList.status === 200) {
				const dataAdminList = resAdminList.data
				for (let i = 0; i < dataAdminList.length; i++) {
					const adminAccess = dataAdminList[i].adminAccess[0] ?? null
					if (
						adminAccess.dataportalServiceID === 2 &&
						// (adminAccess.adminRoleID === 11 || adminAccess.adminRoleID === 15) // show exclusive admin
						(adminAccess.adminRoleID === 11) // not show exclusive admin
					) {
						adminListTemp.push({
							id: dataAdminList[i].id,
							name:
								dataAdminList[i].firstname + ' ' + dataAdminList[i].lastname,
						})
					}
				}

				setCheckerAdminList(adminListTemp)
			}
		}
	}

	const handleExportCSV = async () => {
		Swal.fire({ title: 'กำลังโหลดข้อมูล...', allowOutsideClick: false, didOpen: () => { Swal.showLoading() } })
		const resList = await sdoc.getAllLists({ ...activeFilters, ...gridFilterParamsRef.current, exportAll: true })
		Swal.close()
		if (resList && resList.status === 200) {
			const { data } = resList.data
			const fields = ['runningNumber', 'brandName', 'productModel', 'operator', 'operatorInfo', 'approver', 'submitDate', 'statusLabel']
			const headers = ['เลขที่คำขอ', 'ตราอักษร (Brand Name)', 'รุ่นของผลิตภัณฑ์', 'ผู้ยื่นเอกสาร', 'ยื่นในนาม', 'ผู้ได้รับมอบหมายงาน', 'วันที่ยื่นแบบ', 'สถานะ']
			const rows = data.map((_, i) => {
				const row = createWaitingRow(data, i)
				row.statusLabel = (row.statusID === 2 && row.requestAddtionDocStatusID === 1) ? 'เพิ่มเอกสารแล้ว'
					: (row.statusID === 2 && row.requestAddtionDocStatusID === 2) ? 'ปรับปรุงข้อมูลแล้ว'
						: (row.statusID === 3 && row.requestAddtionDocStatusID === 2) ? 'ขอปรับปรุงเอกสาร'
							: row.statusName
				return row
			})
			const header = headers.join(',')
			const csvRows = rows.map(row => fields.map(f => `"${row[f] ?? ''}"`).join(','))
			const blob = new Blob(['\uFEFF' + [header, ...csvRows].join('\n')], { type: 'text/csv;charset=utf-8;' })
			const link = document.createElement('a')
			link.href = URL.createObjectURL(blob)
			link.download = 'รายการใบคำร้องขอหนังสือรับรอง.csv'
			link.click()
			URL.revokeObjectURL(link.href)
		}
	};

	const forcegetSDOCWaitStatusList = () => {
		setCurrentPage(0)
		getSDOCWaitStatusList(0, activeFilters)
	}

	const getSDOCWaitStatusList = useCallback(async (page = 0, filters = {}, size = pageSize, sort = activeSort) => {
		setIsDataLoading(true);
		setRowsWaitStatus([]);
		getSDocStatusList();

		await admin.me().then(async (event) => {
			if (event) {
				const dataMe = event.data;
				setMyRole(dataMe.roleID);
				setMyID(dataMe.id);

				const resList = await sdoc.getAllLists({ page: page + 1, pageSize: size, ...filters, ...gridFilterParamsRef.current, ...(sort?.field ? { sortField: sort.field, sortOrder: sort.sort } : {}) });
				if (resList && resList.status === 200) {
					const { data: apiDataSDocList, total } = resList.data
					const rowsTemp = apiDataSDocList.map((_, i) => createWaitingRow(apiDataSDocList, i));
					setRowsWaitStatus(rowsTemp);
					setTotalRows(total);
					getCheckerAdminList();
				}
			}
		});
		setIsDataLoading(false);
	}, [pageSize, activeSort]);
	const refreshCurrentPage = () => {
		getSDOCWaitStatusList(currentPage, activeFilters)
	}
	const buildFilterParams = () => {
		const fieldMap = { runningNumber: 'runningNo', brandName: 'brandName', productModel: 'productModel', operator: 'operatorName', operatorInfo: 'operatorInfo', approver: 'approver', refNo1: 'refNo1', refNo2: 'refNo2', invoiceNo: 'invoiceNo' };
		const filters = {};
		searchQuery.forEach(({ id, value }) => { if (value && value.length > 0 && fieldMap[id]) filters[fieldMap[id]] = value; });
		if (searchCreate) filters.submitDate = searchCreate;
		if (searchLastUpdated) filters.lastUpdate = searchLastUpdated;
		if (selectedStatus.length > 0 && selectedStatus[0] !== '0') filters.statusId = selectedStatus.join(',');
		return filters;
	};

	// filter
	const onSearchResult = () => {
		if (isSaveSearch) {
			localStorage.setItem('savedFiltersAll', JSON.stringify({ searchQuery, searchCreate, searchLastUpdated, selectedStatus }));
		} else {
			localStorage.removeItem('savedFiltersAll');
		}
		const filters = buildFilterParams();
		setActiveFilters(filters);
		setCurrentPage(0);
		setIsDialogOpen(false);
		setIsSearching(true);
		getSDOCWaitStatusList(0, filters);
	};

	const applySavedFilters = () => {
		const saved = localStorage.getItem('savedFiltersAll');
		if (saved) {
			const { searchQuery: sq, searchCreate: sc, searchLastUpdated: sl, selectedStatus: ss } = JSON.parse(saved);
			setSearchQuery(sq);
			setSearchCreate(sc || '');
			setSearchLastUpdated(sl || '');
			setSelectedStatus(ss);
			setIsSearching(true);
			setIsSaveSearch(true);
			const fieldMap = { runningNumber: 'runningNo', brandName: 'brandName', productModel: 'productModel', operator: 'operatorName', operatorInfo: 'operatorInfo', approver: 'approver', refNo1: 'refNo1', refNo2: 'refNo2', invoiceNo: 'invoiceNo' };
			const filters = {};
			sq.forEach(({ id, value }) => { if (value && value.length > 0 && fieldMap[id]) filters[fieldMap[id]] = value; });
			if (sc) filters.submitDate = sc;
			if (sl) filters.lastUpdate = sl;
			if (ss.length > 0 && ss[0] !== '0') filters.statusId = ss.join(',');
			setActiveFilters(filters);
			return filters;
		}
		return {};
	};

	const onSearchResultClear = () => {
		setSearchQuery([]);
		setSearchCreate('');
		setSearchLastUpdated('');
		setSelectedStatus([]);
		setIsSearching(false);
		setIsSaveSearch(false);
		setActiveFilters({});
		setCurrentPage(0);
		localStorage.removeItem('savedFiltersAll');
		getSDOCWaitStatusList(0, {});
	};

	const onDeny = useCallback(
		async sDocID => {
			const res = await sdocAdmin.denySDoc(sDocID, remark)
			if (res && res.status === 200) {
				refreshCurrentPage()
				setOpenSubmitSDocSureModal(false)
				setRemark('');
			}
		},
		[refreshCurrentPage, remark]
	)

	const sendToIssue = useCallback(
		async sDocID => {
			const res = await sdocAdmin.sendToIssue(sDocID)
			if (res && res.status === 200) {
				refreshCurrentPage()
				setOpenSubmitSDocSureModal(false)
			}
		},
		[refreshCurrentPage]
	)

	const onSubmitApproval = useCallback(() => {
		if (submitType === 'approve') {
			sendToIssue(currentActionSDoc)
		} else if (submitType === 'reject') {
			onDeny(currentActionSDoc)
		} else if (submitType === 'requestAdditionDoc') {
			onRequestAddition(currentActionSDoc);
		} else if (submitType === 'requestModifyInfo') {
			onRequestModifyInfo(currentActionSDoc);
		} else if (submitType === 'rejectchecker') {
			onDenyChecker(currentActionSDoc)
		}
	}, [onDeny, sendToIssue, currentActionSDoc, submitType])

	const onAssignAdmin = async () => {
		const res = await sdocAdmin.assignAdmin(sDocID, checkerAdminID)
		if (res && res.status === 200) {
			Swal.fire({
				title: 'มอบหมายงานสำเร็จ',
				text: '',
				icon: 'success',
				confirmButtonText: 'ปิด'
			})
			setCheckerAdminID('')
			onOpenModalAssignAdmin()
			refreshCurrentPage()
		}
	}
	const onAssignSignature = async () => {
		const res = await sdocAdmin.approveSDoc(sDocID, myInfo.id)
		if (res && res.status === 200) {
			refreshCurrentPage()
			setOpenModalAssignSignature(false)
			setRemark('');
			if (res.data && res.data.signStatus === 'failed') {
				Swal.fire({
					title: 'อนุมัติสำเร็จ แต่ยังไม่สามารถออกไฟล์หนังสือรับรองได้',
					text: res.data.message || 'ระบบลงลายมือชื่ออิเล็กทรอนิกส์ (Service Portal) ขัดข้อง กรุณาซ่อมแซมหนังสือรับรองอีกครั้งภายหลัง',
					icon: 'warning',
					confirmButtonText: 'ปิด'
				})
			}
		} else {
			Swal.fire({
				title: 'ไม่สามารถดำเนินการอนุมัติได้',
				text: 'เกิดข้อผิดพลาดในการเชื่อมต่อระบบ กรุณาลองใหม่อีกครั้งภายหลัง',
				icon: 'error',
				confirmButtonText: 'ปิด'
			})
		}
	}

	const onRequestAddition = async sDocID => {
		const res = await sdocAdmin.requestAddition(sDocID, remark)
		if (res && res.status === 200) {
			refreshCurrentPage()
			setOpenSubmitSDocSureModal(false);
			setRemark('');
		}
	}
	const onRequestModifyInfo = async sDocID => {
		const res = await sdocAdmin.requestModifyInfo(sDocID, remark)
		if (res && res.status === 200) {
			refreshCurrentPage()
			setOpenSubmitSDocSureModal(false);
			setRemark('');
		}
	}

	const onDenyChecker = useCallback(
		async sDocID => {
			const res = await sdocAdmin.denyCheckerSDoc(sDocID, remark)
			if (res && res.status === 200) {
				refreshCurrentPage()
				setOpenSubmitSDocSureModal(false)
				setRemark('');
			}
		},
		[refreshCurrentPage, remark]
	)

	const onRejectJob = async sDocID => {
		const res = await sdocAdmin.rejectJob(sDocID)
		if (res && res.status === 200) {
			refreshCurrentPage()
		}
	}
	const lastSortKeyRef = useRef('runningNumber|desc');
	const sortTimerRef = useRef(null);
	const handleSortChange = (model) => {
		if (sortTimerRef.current) clearTimeout(sortTimerRef.current);
		sortTimerRef.current = setTimeout(() => {
			const sort = model[0] || { field: '', sort: '' };
			const key = `${sort.field}|${sort.sort}`;
			if (key === lastSortKeyRef.current) return;
			lastSortKeyRef.current = key;
			setSortModel(model);
			setActiveSort(sort);
			setCurrentPage(0);
			if (isRehydrated) {
				getSDOCWaitStatusList(0, activeFilters, pageSize, sort);
			}
		}, 0);
	};
	// Native DataGrid column filter -> server params (same field map as the filter dialog)
	const gridFieldToApi = {
		runningNumber: 'runningNo',
		brandName: 'brandName',
		productModel: 'productModel',
		operator: 'operatorName',
		operatorInfo: 'operatorInfo',
		approver: 'approver',
		refnO1: 'refNo1',
		refnO2: 'refNo2',
		submitDate: 'submitDate',
		lastUpdate: 'lastUpdate',
	};
	const handleFilterChange = (model) => {
		setGridFilterModel(model);
		if (gridFilterTimerRef.current) clearTimeout(gridFilterTimerRef.current);
		gridFilterTimerRef.current = setTimeout(() => {
			const params = {};
			(model.items || []).forEach(({ field, value }) => {
				const key = gridFieldToApi[field];
				if (!key || value === undefined || value === null || value === '') return;
				params[key] = value;
			});
			gridFilterParamsRef.current = params;
			setCurrentPage(0);
			getSDOCWaitStatusList(0, activeFilters);
		}, 500);
	};
	useEffect(() => {
		if (isRehydrated) {
			const savedFilters = applySavedFilters()
			getSDOCWaitStatusList(0, savedFilters)
		}
		//eslint-disable-next-line
	}, [isRehydrated])

	var columnsWaitingStatus = [
		{
			field: 'runningNumber',
			headerName: 'เลขที่คำขอ',
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'brandName',
			headerName: 'ตราอักษร (Brand Name)',
			width: 220,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'productModel',
			headerName: 'รุ่นของผลิตภัณฑ์',
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'operator',
			headerName: 'ผู้ยื่นเอกสาร',
			width: 200,
			headerAlign: 'left',
			align: 'center',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
					{/* {params.row.operator}<br />{params.row.operatorInfo && ('แทน ' + params.row.operatorInfo)} */}
					{params.row.operator}
				</Grid>
			),
			// valueGetter: (params) => {
			// 	if (params.row.operatorInfo) {
			// 		return params.value + ' แทน ' + params.row.operatorInfo + ')'
			// 	}
			// },
		},
		{
			field: 'operatorInfo',
			headerName: 'ยื่นในนาม',
			width: 200,
			headerAlign: 'left',
			align: 'center',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
					{params.row.operatorInfo && (params.row.operatorInfo)}
				</Grid>
			),
		},
		{
			field: 'approver',
			headerName: 'ผู้ได้รับมอบหมายงาน',
			width: 220,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'submitDate',
			headerName: 'วันที่ยื่นแบบ',
			width: 150,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
			renderCell: params => (
				<Grid className="">
					{/* {params.value ? format(new Date(params.value), 'dd/MM/yyyy HH:mm') : ''} */}
					{params.value ? params.value : ''}
				</Grid>
			),
			valueGetter: (value, row) => {
				if (row.submitDate) {
					return format(new Date(value), 'dd/MM/yyyy HH:mm')
				}
			}

		},
		// {
		// 	field: 'submitDateB',
		// 	headerName: 'วันที่ยื่นแบบ(สำหรับค้นหา)',
		// 	width: 150,
		// 	headerAlign: 'left',
		// 	align: 'left',
		// 	sortable: true,
		// 	editable: false,
		// 	hide: true,
		// 	renderCell: params => (
		// 		<Grid className="">
		// 			{/* {params.value ? format(new Date(params.value), 'dd/MM/yyyy HH:mm') : ''} */}
		// 			{params.value ? params.value : ''}
		// 		</Grid>
		// 	),	
		// 	valueGetter: params => {
		// 		if (params.row.submitDate) {
		// 			return format(new Date(params.row.submitDate), 'dd/MM/yyyy HH:mm')
		// 		}
		// 	}

		// },
		{
			field: 'statusID',
			headerName: 'สถานะ',
			width: 130,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
			renderCell: params => {
				var today = new Date();
				today.setDate(today.getDate() + 1);
				var dueDate = null;
				if (params.row.transactions != null && params.row.transactions.dueDate != null) {
					dueDate = new Date(params.row.transactions.dueDate);
				} else {
					dueDate = new Date();
				}
				dueDate.setHours(23, 59, 59, 999);
				return (
					<Grid
						className={`flex flex-row justify-center items-center w-32 h-7 rounded text-xs
						${params.row.statusID === 1
								? classes.waiting_assign_button
								: (params.row.statusID === 2 && params.row.requestAddtionDocStatusID === 0)
									? classes.wait_button
									: params.row.statusID === 4
										? classes.preapprove_button
										: params.row.statusID === 5
											? classes.approve_button
											: (params.row.statusID === 2 && params.row.requestAddtionDocStatusID === 1) || (params.row.statusID === 2 && params.row.requestAddtionDocStatusID === 2)
												? classes.updated_button
												: params.row.statusID === 6
													? classes.reject_button
													: (params.value === 8 && (dueDate < today)) ?
														classes.reject_button
														: params.row.statusID === 10
															? classes.cancel_button
															: classes.common_button
							}
					`}>
						{
							(params.row.statusID === 2 && params.row.requestAddtionDocStatusID === 1) ?
								'เพิ่มเอกสารแล้ว'
								: (params.row.statusID === 2 && params.row.requestAddtionDocStatusID === 2) ?
									'ปรับปรุงข้อมูลแล้ว'
									: (params.row.statusID === 3 && params.row.requestAddtionDocStatusID === 2) ?
										'ขอปรับปรุงเอกสาร'
										: (params.row.statusID === 8 && (dueDate < today)) ?
											'เลยกำหนดชำระ'
											: params.row.statusName
						}
					</Grid>
				)
			},
			valueGetter: (value, row) => {
				{
					var today = new Date();
					today.setDate(today.getDate() + 1);
					var dueDate = null;
					if (row.transactions != null && row.transactions.dueDate != null) {
						dueDate = new Date(row.transactions.dueDate);
					} else {
						dueDate = new Date();
					}
					dueDate.setHours(23, 59, 59, 999);

					if (value === 2 && row.requestAddtionDocStatusID === 1)
						return 'เพิ่มเอกสารแล้ว';
					else if (value === 2 && row.requestAddtionDocStatusID === 2)
						return 'ปรับปรุงข้อมูลแล้ว';
					else if (value === 3 && row.requestAddtionDocStatusID === 2)
						return 'ขอปรับปรุงเอกสาร';
					else if (value === 8 && (dueDate < today))
						return 'เลยกำหนดชำระ';
					else
						return row.statusName;
				}
			},
		},
		{
			field: 'activity',
			headerName: 'กิจกรรม',
			width: 1000,
			headerAlign: 'left',
			align: 'left',
			sortable: false,
			filterable: false,
			editable: false,
			renderCell: params => {
				return (
					<Grid className="flex flex-row justify-start items-center w-full gap-x-2">
						<Button
							className={`w-24`}
							color="primary"
							variant="contained"
							onClick={() => {
								history.push(
									`/admin/sdoc/form/${params.row.id}?mountType=readOnly`
								)
							}}>
							<Menu style={{ fontSize: 16 }} className="mr-1" />
							<Grid className={`text-xs`}>รายละเอียด</Grid>
						</Button>
					</Grid>
				)
			},
		},

	]
	return (
		<>
			<Grid className="flex flex-col">
				<Grid className="py-10 px-3 sm:px-10">
					<Card className={`border-t-4 border-card_top_border`}>
						<Grid className="flex flex-col justify-center items-start overflow-auto mb-5">
							<Grid className="flex flex-row items-center mt-4 mb-3 px-5">
								<Grid>
									<ListAlt style={{ fontSize: 22 }} className="mr-1" />
								</Grid>
								<Grid className="font-bold text-sm text-card_header_color">
									รายการคำร้องขอหนังสือรับรองตนเอง
								</Grid>
							</Grid>
							<Grid className="flex flex-row items-center mt-4 mb-3 px-5 gap-x-2">
								<Button
									className={`w-36`}
									color="primary"
									variant="contained"
									onClick={toggleDialog}>
									<Search style={{ fontSize: 16 }} className="mr-1" />
									<Grid className={`text-xs`}>ค้นหาขั้นสูง</Grid>
								</Button>
								<Button
									className={`w-72`}
									color="primary"
									variant="contained"
									onClick={handleExportCSV}>
									<Grid className={`text-xs`}>ดาวน์โหลดรายการใบคำร้องขอหนังสือรับรอง</Grid>
								</Button>
							</Grid>
							<Grid className="md:px-5" style={{ height: '80vh', width: '100%', overflow: 'hidden' }}>
								<DataGrid
									rows={rowsWaitStatus}
									columns={columnsWaitingStatus}
									loading={isDataLoading}
									paginationMode="server"
									rowCount={totalRows}
									paginationModel={{ page: currentPage, pageSize }}
									onPaginationModelChange={(model) => {
										const pageSizeChanged = model.pageSize !== pageSize
										setPageSize(model.pageSize)
										setCurrentPage(pageSizeChanged ? 0 : model.page)
										getSDOCWaitStatusList(pageSizeChanged ? 0 : model.page, activeFilters, model.pageSize)
									}}
									pageSizeOptions={[5, 10, 25, 50]}
									disableRowSelectionOnClick
									sortingMode="server"
									filterMode="server"
									filterModel={gridFilterModel}
									onFilterModelChange={handleFilterChange}
									rowHeight={66}
									onSortModelChange={(model) => {
										handleSortChange(model)
									}}
									slots={{
										pagination: CustomPagination,
										noRowsOverlay: () => <GridOverlay>ไม่พบข้อมูล</GridOverlay>,
									}}
									slotProps={{
										loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' },
									}}
									sx={{ fontFamily: 'Sarabun, sans-serif', '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' } }}
								/>
							</Grid>
						</Grid>
					</Card>
				</Grid >
			</Grid >

			<SureModal
				open={openSubmitSDocSureModal}
				title={sureModalTitle}
				content={contentSureModal}
				onClose={() => {
					setOpenSubmitSDocSureModal(false)
				}}
				handleButton={onSubmitApproval}
				handleCancel={() => {
					setOpenSubmitSDocSureModal(false)
				}}
			/>

			<SelectAssignAdminModal
				open={openModalAssignAdmin}
				onClose={onOpenModalAssignAdmin}
				handleButton={onAssignAdmin}
				onChangeCheckerAdminID={onChangeCheckerAdminID}
				checkerAdminList={checkerAdminList}
				checkerAdminID={checkerAdminID}
			/>

			<SignSignatureModal
				open={openModalAssignSignature}
				onClose={() => setOpenModalAssignSignature(false)}
				handleButton={onAssignSignature}
				onChangeCheckerAdminID={onChangeSignature}
				checkerAdminList={signatureAdminList}
				checkerAdminID={selectedSignature}
			/>

			<Dialog
				className="w-full"
				fullScreen={isMobile}
				maxWidth="md"
				fullWidth
				scroll="paper"
				open={isDialogOpen}
				onClose={toggleDialog}>
				<DialogTitle style={{ backgroundColor: '#a74345' }}>
					<Grid
						container
						direction="row"
						justifyContent="space-between"
						alignItems="center">
						<Grid className="flex flex-row items-center" component="div">
							<Grid className="text-white">ค้นหาขั้นสูง</Grid>
						</Grid>
						<IconButton onClick={toggleDialog} style={{ color: '#fff' }}>
							<Close />
						</IconButton>
					</Grid>
				</DialogTitle>
				<DialogContent dividers>
					<div className="w-full" style={{ textAlign: 'left' }}>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>เลขที่คำขอ:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'runningNumber')?.value || ''}
									placeholder="(ไม่ต้องใส่ SR นำหน้า)"
									id="runningNumber"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ตราอักษร:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'brandName')?.value || ''}
									id="brandName"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>รุ่นของผลิตภัณฑ์:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'productModel')?.value || ''}
									id="productModel"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ผู้ยื่นเอกสาร:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'operator')?.value || ''}
									id="operator"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ยื่นในนาม:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'operatorInfo')?.value || ''}
									id="operatorInfo"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ผู้ได้รับมอบหมายงาน:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'approver')?.value || ''}
									id="approver"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>วันที่ยื่นแบบ:</div>
							<div className="flex-1">
								<TextField
									style={isMobile ? { width: '100%' } : { maxWidth: '200px', width: '200px' }}
									type="date"
									value={searchCreate}
									onChange={handleCreateChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>สถานะ:</div>
							<div className="flex-1">
								<Select
									className="w-full"
									value={selectedStatus}
									onChange={handleStatusChange}
									multiple
									MenuProps={{
										anchorOrigin: {
											vertical: "bottom",
											horizontal: "left"
										},
										transformOrigin: {
											vertical: "top",
											horizontal: "left"
										},
										getContentAnchorEl: null
									}}
									renderValue={(selected) => {
										const selectedLabels = selected.map(value => {
											const selectedOption = statusOptions.find(option => option.value === value);
											return selectedOption ? selectedOption.label : '';
										});
										return (
											<span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
												{selectedLabels.join(', ')}
											</span>
										);
									}}
								>
									{statusOptions.map((option) => (
										<MenuItem key={option.value} value={option.value}>
											<Checkbox checked={selectedStatus.indexOf(option.value) > -1} />
											<ListItemText primary={option.label} />
										</MenuItem>
									))}
								</Select>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>หมายเลขอ้างอิง 1:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'refNo1')?.value || ''}
									id="refNo1"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>หมายเลขอ้างอิง 2:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'refNo2')?.value || ''}
									id="refNo2"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>เลขที่ใบเสร็จรับเงิน:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'invoiceNo')?.value || ''}
									id="invoiceNo"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>บันทึกข้อมูลการค้นหา:</div>
							<div className="flex-1">
								<Switch
									checked={isSaveSearch}
									onChange={handleSaveSearch}
									color="primary"
								/>
							</div>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<Grid
						className={isMobile ? "w-full px-2 flex flex-col gap-2" : "w-8/12 mx-auto flex flex-row justify-between items-center"}
						component="div">
						<Button
							className={isMobile ? "w-full" : "w-5/12"}
							onClick={onSearchResultClear}
							color="secondary"
							variant="outlined">
							ล้างผลการค้นหา
						</Button>
						<Button
							className={isMobile ? "w-full" : "w-5/12"}
							color="primary"
							variant="contained"
							onClick={onSearchResult}>
							ค้นหา
						</Button>
					</Grid>
				</DialogActions>
			</Dialog>

		</>
	)
}
